<template>
	<div class="WelcomeScreen">
		<SectionWrapper class="Cover" :backgroundImage="require(`@/assets/imgs/main/photo-01.webp`)">
		</SectionWrapper>

		<SectionWrapper class="FistSection" title="El Club"
			description="Espartanas está registrado como Club Deportivo Elemental en la Comunidad de Madrid y cuenta con estructura organizativa y cuenta bancaria propia para la gestión del equipo."
			:useGradientBackground="false">

			<p>Esto permite colaborar con patrocinadores y gestionar oficialmente las actividades del club.</p>

			<template slot="noPadding">
				<SplideWrapper class="Addons" v-if="addons.length" :items="addons" type="Images" :avoidWide="false"
					:heightAuto="false" :autoWidthProp="false" :useGradientBackground="false"></SplideWrapper>
			</template>
		</SectionWrapper>
		<SectionWrapper title="Entrenamientos" :backgroundImage="require(`@/assets/imgs/main/photo-07.webp`)"
			:imageOpacity="0.1"
			description="Entrenamos semanalmente en Madrid, combinando técnica, estratégia y preparación física."
			:useGradientBackground="false">
			<div class="TextContent">
				<Icon icon="calendar" :size="isMobile ? 18 : 22" color="primary" />
				<p><b>Martes y Jueves</b> <b class="gray">·</b> 20:00h <b class="gray">·</b> Vicálvaro
					<br /><b>Domingos</b> <b class="gray">·</b> 11:00h <b class="gray">·</b> Lago
					<br /><i>Los horarios pueden variar según la época del año.</i>
				</p>

				<!-- <p>Martes y Jueves a las 20h en Vicálvaro
					<br />Domingos a las 11h en Lago
				</p> -->
			</div>
			<div class="TextContent">
				<Icon icon="clock" :size="isMobile ? 18 : 22" color="primary" />
				<p>Duración: 2h
				</p>
			</div>
			<div class="TextContent">
				<Icon icon="map-pin" :size="isMobile ? 18 : 22" color="primary" />
				<div class="flex">
					<p>Dónde entrenamos
					</p>
					<div class="FlexBox setMargin">
						<!-- @click="openModal(image)" -->
						<div v-for="({ src, name }, index) in trainingVenues" :key="index" class="FlexItem wide">

							<p class="Name"><b>{{ name }}</b></p>
							<iframe :src="src" width="100%" height="100%" style="border:0" allowfullscreen="" loading="lazy"
								referrerpolicy="no-referrer-when-downgrade" />
						</div>
					</div>
				</div>
			</div>
			<div class="TextContent">
				<Icon icon="briefcase" :size="isMobile ? 18 : 22" color="primary" />
				<p>
					Recomendamos llevar...
					<!-- <br><span class="bullet-dot">👖</span> Pantalon deportivo largo
					<br><span class="bullet-dot">🧤</span> Toalla y/o guantes para físico
					<br><span class="bullet-dot">💧</span> Agua -->
					<br><span class="bullet-dot">&bull;</span> Pantalon deportivo largo
					<br><span class="bullet-dot">&bull;</span> Toalla y/o guantes para físico
					<br><span class="bullet-dot">&bull;</span> Agua
				</p>
			</div>
			<template slot="noPadding">
				<SplideWrapper v-if="trainingVideos.length" :items="trainingVideos" class="Videos" type="Shorts"
					:avoidWide="false" :contentSize="{ width: isMobile ? '100%' : 550, height: isMobile ? 'auto' : 315 }"
					:useGradientBackground="false"></SplideWrapper>
			</template>
		</SectionWrapper>



		<!-- :heightAuto="false" -->
		<!-- https://www.youtube.com/embed/videoseries -->

		<SectionWrapper title="Organización"
			description="El club se sostiene gracias al trabajo conjunto de jugadoras y comité organizativo."
			:useGradientBackground="true">

			<div class="TextContent">
				<Icon icon="dollar-sign" :size="isMobile ? 18 : 22" color="primary" />
				<p>Para financiar nuestras actividades, cada jugadora aporta una cuota de <b>10Є mensuales</b>.

					<br />
					Las nuevas jugadoras pueden asistir al primer mes gratuitamente.
					<!-- <br />
					Nuestra tesorera es la encargada de administrar esta caja chica.
					<br />
					El club dispone de una cuenta bancaria propia para la gestión de cuotas y actividades. -->
				</p>
			</div>



			<!-- <div class="TextContent">
				<Icon icon="flag" :size="isMobile ? 18 : 22" color="primary" />
				<p>Tenemos un <b>Reglamento Interno</b>, en el cual están definidos los objetivos del club. Para formar
					parte del equipo es necesario firmarlo.
				</p>
			</div> -->

			<div class="TextContent">
				<Icon icon="flag" :size="isMobile ? 18 : 22" color="primary" />
				<div class="block">

					<p>Tenemos un comité organizativo encargado de realizar toda la organización y gestión general.
					</p>
					<div class="FlexBox setMargin">
						<div v-for="({ roles, image }, index) in comiteMembers" :key="index" class="FlexItem profile">
							<div class="ProfilePicture"
								:style="{ backgroundImage: `url(${require(`@/assets/imgs/roster/${image}`)})` }" />
							<!-- <p class="Name">
								{{ name }}
							</p> -->
							<!-- <p class="Role">
								{{ role }}
							</p> -->
							<div class="OptionGroup">
								<div v-for="(role, key) in roles" :key="key" class="Option">
									{{ role }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="TextContent">
				<Icon icon="message-square" :size="isMobile ? 18 : 22" color="primary" />
				<p>Buscamos seguir creciendo dentro y fuera del campo.
					<br />
					Si tienes alguna sugerencia, idea o comentario, puedes hablar con nosotras directamente o utilizar
					nuestro <b><a href="https://n9.cl/buzon-sugerencias" class="Link" target="_blank">Buzón de Sugerencias
							online</a></b>.
				</p>
			</div>

		</SectionWrapper>


		<!-- <SplideWrapper class="HistorySection" v-if="historyByYear.length" :items="historyByYear" type="CollageByFolder"
			:useGradientBackground="false" title="Nuestra historia"
			description="Un recorrido por los años que han construido nuestro equipo." :heightAuto="true">
		</SplideWrapper> -->
		<SplideWrapper class="HistorySection" v-if="historyByYear2.length" :items="historyByYear2" type="Collage"
			:useGradientBackground="false" title="Nuestra historia"
			description="Un recorrido por los años que han construido nuestro equipo." :heightAuto="true">
		</SplideWrapper>
		<!-- <SplideWrapper class="HistorySection" v-if="historySecond.length" :items="historySecond" type="Images"
			:useGradientBackground="false" :useArrows="false" :heightAuto="false">
		</SplideWrapper>
		<SplideWrapper class="HistorySection" v-if="historyThird.length" :items="historyThird" type="Images"
			:useGradientBackground="false" :useArrows="false" :heightAuto="false">
		</SplideWrapper> -->

		<SectionWrapper class="SpartanSection" title="¿Por qué Espartanas?" backgroundImagePositionY="bottom"
			description="Leales a nuestro escudo. Fuertes como equipo."
			:backgroundImage="require(`@/assets/imgs/main/photo-04.webp`)" :imageOpacity="0.1">
			<p>
				Esparta no tenía ejército, lo era.
				<a href="https://youtu.be/aN_2D_e4INY" target="_blank" class="Link"> Los soldados espartanos </a> fueron
				conocidos en la historia como grandes guerreros. Eran
				los más disciplinados y entrenados de la antigua Grecia; fueron admirados y temidos en su propio tiempo.
			</p>
			<!-- <p>
				<br />
				Nos sentimos identificadas con el
				<a href="https://www.instagram.com/p/B_h5ALtIOvK/?igshid=1j243a778flqh" target="_blank" class="Link">
					Código Espartano</a>. ¡AU AU!
			</p> -->
		</SectionWrapper>


		<Modal :isOpen="isModalOpen" @close="isModalOpen = false">
			<template #body>
			</template>
		</Modal>
	</div>
</template>

<script>
import { mediaQueryMixin } from "@/mixins";
import { comiteMembers, tecnicMembers, trainingVenues, socialMedia, historyByYear, historyByYear2, addons, trainingVideos } from '@/utils/publicData'
import { Bullet, SplideWrapper, SectionWrapper } from '@/components'

export default {
	name: 'WelcomeScreen',
	components: {
		Bullet,
		SplideWrapper,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			modalImage: '',
			isModalOpen: false,
			addons,
			// https://youtube.com/playlist?list=PLcbilcgW88ITOHksQt9s5JlNVCtRJDlk2&si=qAsVpfeMlecsHlfs
			trainingVideos,
			historyByYear,
			historyByYear2,
			comiteMembers,
			tecnicMembers,
			trainingVenues,
			socialMedia,
		}
	},
	computed: {
		isMobile() {
			return this.$mq.w < this.$mq.sm.min;
		},
		// historyFirst() {
		// 	return history.filter(e => e.folder === '1')
		// },
		// historySecond() {
		// 	return history.filter(e => e.folder === '2')
		// },
		// historyThird() {
		// 	return history.filter(e => e.folder === '3')
		// },
	},
	methods: {
		openModal(value) {
			this.isModalOpen = true
			this.modalImage = value
		},
	},
}
</script>

<style lang="scss" scoped>
.WelcomeScreen {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: white;
}

.gray {
	color: $gray-medium;
	padding: 0 4px;
}

.TextContent {
	display: flex;
	margin-bottom: 1.5rem;

	.flex {
		flex: 1
	}

	.block {
		width: 100%
	}

	.bullet-dot {
		color: $primary;
		margin-right: 10px;
	}


	.OptionGroup {
		display: flex;
		flex-wrap: wrap;
		gap: 4px;

		.Option {
			display: inline-block;
			padding: 4px 12px 6px 12px;
			border-radius: 50px;
			font-size: 1rem;
			line-height: 1rem;
			color: $primary;
			background-color: rgba($primary, 0.05);
			font-weight: $font-weight-semibold;
			transition: all 0.3s;
			user-select: none;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 250px;
			font-weight: $font-weight-semibold;
			color: $white;
			background-color: rgba($gray-dark, 1);

			@media screen and (max-width: $md) {
				font-size: .9rem;
				line-height: .9rem;
				padding: 4px 10px 6px 10px;
			}
		}
	}

	.Icon {
		margin-right: 25px;
		margin-top: 4px;

		@media screen and (max-width: $sm) {
			margin-right: 12px;
			margin-top: 8px;
		}
	}

	p {
		font-size: 1rem;
		line-height: 2rem;
	}
}

.Cover {
	position: absolute;
	height: 20rem;
	width: 100%;
	top: 0;
	left: 0;

	&::v-deep.SectionWrapper {
		.Image {
			background-position-y: top;
		}
	}

	@media screen and (max-width: $sm) {
		height: 12rem;
	}
}

.FistSection {
	margin-top: 20rem;


	@media screen and (max-width: $sm) {
		margin-top: 12rem;
	}

}

.Addons {
	&::v-deep .splide__track {

		.splide__slide {
			width: 16rem !important;
			height: 16rem !important;

			@media screen and (max-width: $sm) {
				width: 12rem !important;
				height: 12rem !important;
			}
		}
	}
}

.HistorySection {


	&::v-deep .splide__track {
		.splide__slide {
			height: 18rem;
			width: 26rem !important;

			// @media screen and (max-width: $md) {
			// 	width: 80% !important;
			// }

			@media screen and (max-width: $sm) {
				height: 16rem;
				width: 20rem !important;
			}
		}
	}
}

.Videos {
	height: auto;
}

.SpartanSection {
	margin-top: 2rem;
	padding-top: 2rem;
	padding-bottom: 10rem;

	@media screen and (max-width: $md) {
		margin-top: 0;
		padding-bottom: 8rem;
	}

}

.Link {
	color: $gray-medium;
	text-decoration: underline;
}

.Picture {
	height: 32rem;
	width: 100%;
	background-size: cover;
	background-repeat: no-repeat;
	background-position-x: center;
	background-position-y: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding-top: 30px;

	@media screen and (max-width: $md) {
		height: auto;
	}

	p {
		font-size: 1.2rem;
	}

	&.small {
		height: 23rem;

		@media screen and (max-width: $md) {
			height: auto;
		}
	}
}

.Text {
	width: 80%;
}

.FlexBox {
	width: 100%;
	display: flex;
	gap: 1rem;

	@media screen and (max-width: $lg) {
		gap: 1rem;
	}

	@media screen and (max-width: $md) {
		flex-wrap: wrap;
	}

	@media screen and (max-width: $sm) {
		flex-wrap: wrap;
	}

	&.setMargin {
		margin-top: 1rem;

	}

	.FlexItem {
		background: white;
		overflow: hidden;
		border-radius: 1rem;
		box-shadow: 0px 4px 10px rgba(103, 94, 134, 0.1);
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 1.2rem;
		width: 12rem;

		@media screen and (max-width: $lg) {
			flex: 1;
		}

		@media screen and (max-width: $sm) {
			width: 45%;
			flex: none;
		}

		&.wide {
			width: 26rem;
			flex: none;
			background: none;
			align-items: flex-start;
			box-shadow: none;
			border-radius: 0 0 1rem 1rem;
			padding-bottom: 0;

			iframe {
				border-radius: 1rem;
			}

			.Name {
				color: $gray-medium !important;
				margin-top: 0;
				margin-bottom: 1rem;
				// font-size: 1.2rem !important;

			}

			@media screen and (max-width: $lg) {
				width: 26rem;
			}

			@media screen and (max-width: $md) {
				flex: 1;
				margin-bottom: 1rem;
			}

			@media screen and (max-width: $sm) {
				width: 100%;
				flex: none;
			}
		}

		.ProfilePicture {
			width: 100%;
			height: 15rem;
			background-position-x: center;
			background-position-y: top;
			background-size: cover;
			background-repeat: no-repeat;

			@media screen and (max-width: $md) {
				height: 10rem;
			}
		}

		&.profile {
			position: relative;
			padding-bottom: 0;
			height: 15rem;

			@media screen and (max-width: $md) {
				height: 12rem;
			}

			.ProfilePicture {
				height: 100%;
			}

			.OptionGroup {
				position: absolute;
				bottom: 6px;
			}
		}

		.Name {
			margin-top: 1.2rem;
			color: $gray-dark !important;
			font-weight: 500;
			font-size: 1rem;
			line-height: 1rem;
			text-align: center;
		}

		.Role {
			text-transform: uppercase;
			font-size: 1rem;
			line-height: 1rem;
			color: $gray-03;
			font-weight: 600;
			margin-top: .5rem;
			text-align: center;
		}

		.Location {
			font-size: 14px;
			color: $gray-01;
			font-weight: 500;
			margin-top: 5px;
			line-height: 16px;
			text-align: center;

			.nowrap {
				white-space: nowrap;
			}
		}
	}
}



.align-center {
	text-align: center;
}

.Modal::v-deep {
	.Dialog {
		max-width: 80%;
	}

	.Body {
		display: flex;
		align-items: center;
		justify-content: center;

		.ImageWrapper {
			width: calc(100% - 40px);
			border-radius: 10px;
			min-height: 700px;
			margin-bottom: 20px;
			background-size: cover;
			background-repeat: no-repeat;
			background-position-x: center;
			background-position-y: center;
		}
	}
}
</style>
